/**
 * Harry Potter · Marauder's Map auf der Startseite
 */
(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FOOTPRINT_SVG =
    '<svg viewBox="0 0 32 72" fill="currentColor" aria-hidden="true">' +
    '<ellipse cx="16" cy="21" rx="13" ry="18"/>' +
    '<ellipse cx="16" cy="56" rx="9.4" ry="10.6"/>' +
    '</svg>';

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function pointOnPolyline(points, t) {
    const last = points.length - 1;
    const scaled = t * last;
    const i = Math.min(last - 1, Math.floor(scaled));
    const local = scaled - i;
    const a = points[i];
    const b = points[i + 1];
    return {
      x: lerp(a[0], b[0], local),
      y: lerp(a[1], b[1], local),
    };
  }

  function headingOnPolyline(points, t) {
    const delta = 0.02;
    const a = pointOnPolyline(points, Math.max(0, t - delta));
    const b = pointOnPolyline(points, Math.min(1, t + delta));
    return (Math.atan2(b.y - a.y, b.x - a.x) * 180) / Math.PI + 90;
  }

  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function startWalkers(root) {
    if (REDUCED || document.querySelector('.hp-home-walkers')) return;

    const layer = document.createElement('div');
    layer.className = 'hp-home-walkers';
    layer.setAttribute('aria-hidden', 'true');
    const printColor = getComputedStyle(root).getPropertyValue('--hp-home-print').trim();
    if (printColor) layer.style.setProperty('--hp-home-print', printColor);
    document.body.appendChild(layer);

    const routes = [
      [
        [6, 10],
        [16, 16],
        [26, 20],
        [36, 26],
        [46, 38],
        [56, 54],
        [68, 70],
        [80, 82],
        [92, 90],
      ],
      [
        [94, 16],
        [82, 26],
        [70, 38],
        [56, 48],
        [40, 60],
        [24, 74],
        [10, 88],
      ],
      [
        [4, 58],
        [18, 50],
        [36, 46],
        [54, 52],
        [72, 40],
        [88, 28],
        [98, 18],
      ],
      [
        [12, 86],
        [28, 72],
        [44, 58],
        [58, 42],
        [74, 28],
        [90, 14],
      ],
    ];

    const narrow = window.matchMedia('(max-width: 720px)').matches;
    const pace = narrow ? 520 : 430;
    const steps = narrow ? 9 : 12;
    let stopped = false;

    function stamp(x, y, angle, isLeft) {
      const print = document.createElement('span');
      print.className = 'hp-home-print';
      print.style.left = `${x}%`;
      print.style.top = `${y}%`;
      print.style.setProperty('--hp-print-rot', `${angle}deg`);
      print.style.setProperty('--hp-print-flip', isLeft ? '1' : '-1');
      print.style.setProperty('--hp-print-life', narrow ? '2.4s' : '2.9s');
      print.innerHTML = FOOTPRINT_SVG;
      layer.appendChild(print);
      print.addEventListener('animationend', () => print.remove(), { once: true });
    }

    async function walk(route) {
      for (let i = 0; i < steps; i += 1) {
        if (stopped) return;
        if (document.hidden) {
          await wait(400);
          i -= 1;
          continue;
        }
        const t = i / (steps - 1);
        const point = pointOnPolyline(route, t);
        const angle = headingOnPolyline(route, t);
        const rad = ((angle - 90) * Math.PI) / 180;
        const side = i % 2 === 0 ? -1 : 1;
        const offset = narrow ? 0.55 : 0.7;
        stamp(
          point.x + Math.cos(rad + Math.PI / 2) * offset * side,
          point.y + Math.sin(rad + Math.PI / 2) * offset * side,
          angle,
          side < 0
        );
        await wait(pace);
      }
    }

    async function loopWalker(route, delay) {
      await wait(delay);
      while (!stopped) {
        await walk(route);
        await wait(2600 + Math.random() * 4200);
      }
    }

    const activeRoutes = narrow ? [routes[0], routes[2]] : routes;
    activeRoutes.forEach((route, index) => {
      loopWalker(route, 600 + index * 1800);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) layer.replaceChildren();
    });
  }

  function revealSpell(root) {
    const labels = [root.dataset.labelA, root.dataset.labelB]
      .map((value) => (value || '').trim())
      .filter(Boolean);
    if (!labels.length) return;

    const href = root.dataset.url || '/pages/harry-potter';
    const button = document.createElement('a');
    button.className = 'hp-home-spell hp-home-spell--br';
    button.href = href;
    button.style.setProperty('--hp-spell-tilt', `${(Math.random() * 4 - 2).toFixed(2)}deg`);
    button.innerHTML =
      `<span class="hp-home-spell__mark">${FOOTPRINT_SVG}</span>` +
      `<span>${pick(labels)}</span>`;

    document.body.appendChild(button);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        button.classList.add('is-visible');
      });
    });
  }

  function init() {
    const root = document.querySelector('[data-hp-home-map]');
    if (!root) return;
    startWalkers(root);
    window.setTimeout(() => revealSpell(root), REDUCED ? 0 : 1400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
